import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const August = () => {
    return (
        <Fragment>{SkipDays(6, 1, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 21, 22, 23, 24, 25, 31], true)}</Fragment>  
    )
}